// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   MANAGE LICENSE MODULE DESIGN THEME
   ========================================================================== */

.manage-license-dashboard-container {
  padding: 32px;
  background-color: #f8fafc;
  border-radius: 16px;
  min-height: 100vh;
  font-family: 'Inter', system-ui, sans-serif;
}

.manage-license-header-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 28px;
}

.manage-license-header-wrapper h2 {
  font-size: 24px;
  color: #0f172a;
  margin: 0 0 4px 0;
  font-weight: 700;
}

.manage-license-subtitle {
  font-size: 14px;
  color: #64748b;
  margin: 0;
}

.manage-license-btn-refresh-global {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background-color: #ffffff;
  color: #475569;
  padding: 10px 18px;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.manage-license-btn-refresh-global:hover {
  background-color: #f8fafc;
  color: #0f172a;
}

.manage-license-btn-icon {
  width: 16px;
  height: 16px;
}

/* GRIDS AND CARDS */
.manage-license-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 20px;
  margin-bottom: 32px;
}

.manage-license-card {
  background: #ffffff;
  padding: 22px;
  border-radius: 14px;
  border: 1px solid #e2e8f0;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
}

.manage-license-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.manage-license-card h3 {
  font-size: 13px;
  color: #64748b;
  margin: 0 0 8px 0;
  align-item: center;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.manage-license-card p {
  font-size: 28px;
  font-weight: 800;
  color: #0f172a;
  margin: 0 0 6px 0;
}

.manage-license-filter-indicator {
  font-size: 11px;
  color: #94a3b8;
  display: block;
}

/* Active State for Card Filter */
.manage-license-active-card-filter {
  background-color: #f1f5f9;
  border-bottom: 2px solid #0f172a;
}

/* ADD NEW LICENSE CARD */
.manage-license-add-card {
  background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);
  max-width: 150px;
  border: none;
}
.manage-license-add-card h3 { color: #94a3b8; }
.manage-license-add-card p { color: #ffffff; font-size: 20px; }
.manage-license-add-card .manage-license-filter-indicator { color: #64748b; }

/* ACTIONS BAR */
.manage-license-table-actions-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  gap: 16px;
}

.manage-license-search-box-wrapper {
  position: relative;
  flex: 1 1;
  max-width: 480px;
}

.manage-license-search-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  color: #94a3b8;
}

.manage-license-search-input {
  width: 100%;
  padding: 10px 14px 10px 40px;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  font-size: 14px;
  background-color: #ffffff;
  box-sizing: border-box;
}

.manage-license-active-filter-badge {
  font-size: 13px;
  color: #475569;
  background-color: #e2e8f0;
  padding: 6px 14px;
  border-radius: 8px;
}

/* DATA TABLE CONFIG */
.manage-license-responsive-table-wrapper {
  background: #ffffff;
  border-radius: 14px;
  border: 1px solid #e2e8f0;
  overflow-x: auto;
}

.manage-license-pro-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  font-size: 14px;
}

.manage-license-pro-table th {
  background-color: #f8fafc;
  color: #475569;
  font-weight: 600;
  padding: 14px 20px;
  border-bottom: 1px solid #e2e8f0;
}

.manage-license-pro-table td {
  padding: 14px 20px;
  border-bottom: 1px solid #f1f5f9;
  color: #334155;
}

.manage-license-text-bold {
  font-weight: 600;
  color: #0f172a;
}

.manage-license-network-badge {
  background-color: #f1f5f9;
  color: #475569;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  border: 1px solid #e2e8f0;
}

.manage-license-key-display-block {
  background-color: #f8fafc;
  padding: 4px 8px;
  border-radius: 6px;
  font-family: monospace;
  color: #2563eb;
  border: 1px solid #e2e8f0;
}

/* STATUS BADGES SPECIFIC TO LICENSE INTERNAL VALUES */
.manage-license-status-badge {
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: capitalize;
  display: inline-block;
}
.manage-license-status-badge.active { background-color: #dcfce7; color: #15803d; }
.manage-license-status-badge.expired { background-color: #fef3c7; color: #d97706; }
.manage-license-status-badge.disabled { background-color: #fee2e2; color: #b91c1c; }

/* ACTIONS ROW TRIGGER GROUP */
.manage-license-table-row-actions {
  display: flex;
  gap: 6px;
}

.manage-license-btn-row-action {
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  border: 1px solid transparent;
  transition: all 0.15s ease;
}

.manage-license-btn-copy { background-color: #eff6ff; color: #1d4ed8; }
.manage-license-btn-edit { background-color: #f1f5f9; color: #334155; border-color: #cbd5e1; }
.manage-license-btn-revoke { background-color: #fff5f5; color: #dc2626; }

.manage-license-btn-copy:hover { background-color: #dbeafe; }
.manage-license-btn-edit:hover { background-color: #e2e8f0; }
.manage-license-btn-revoke:hover { background-color: #fee2e2; }

/* SPINNER & EMPTY STATE */
.manage-license-loading-spinner-wrapper, .manage-license-no-data-cell {
  text-align: center;
  padding: 60px 20px;
  color: #64748b;
}

.manage-license-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #e2e8f0;
  border-top-color: #2563eb;
  border-radius: 50%;
  margin: 0 auto 16px auto;
  animation: lic-spin 0.8s linear infinite;
}

@keyframes lic-spin {
  to { transform: rotate(360deg); }
}
`, "",{"version":3,"sources":["webpack://./src/components/License/ManageLicense.css"],"names":[],"mappings":"AAAA;;+EAE+E;;AAE/E;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA,yBAAyB;AACzB;EACE,6DAA6D;EAC7D,gBAAgB;EAChB,YAAY;AACd;AACA,8BAA8B,cAAc,EAAE;AAC9C,6BAA6B,cAAc,EAAE,eAAe,EAAE;AAC9D,4DAA4D,cAAc,EAAE;;AAE5E,gBAAgB;AAChB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,sDAAsD;AACtD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;AACvB;AACA,sCAAsC,yBAAyB,EAAE,cAAc,EAAE;AACjF,uCAAuC,yBAAyB,EAAE,cAAc,EAAE;AAClF,wCAAwC,yBAAyB,EAAE,cAAc,EAAE;;AAEnF,8BAA8B;AAC9B;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA,2BAA2B,yBAAyB,EAAE,cAAc,EAAE;AACtE,2BAA2B,yBAAyB,EAAE,cAAc,EAAE,qBAAqB,EAAE;AAC7F,6BAA6B,yBAAyB,EAAE,cAAc,EAAE;;AAExE,iCAAiC,yBAAyB,EAAE;AAC5D,iCAAiC,yBAAyB,EAAE;AAC5D,mCAAmC,yBAAyB,EAAE;;AAE9D,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC","sourcesContent":["/* ==========================================================================\n   MANAGE LICENSE MODULE DESIGN THEME\n   ========================================================================== */\n\n.manage-license-dashboard-container {\n  padding: 32px;\n  background-color: #f8fafc;\n  border-radius: 16px;\n  min-height: 100vh;\n  font-family: 'Inter', system-ui, sans-serif;\n}\n\n.manage-license-header-wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 28px;\n}\n\n.manage-license-header-wrapper h2 {\n  font-size: 24px;\n  color: #0f172a;\n  margin: 0 0 4px 0;\n  font-weight: 700;\n}\n\n.manage-license-subtitle {\n  font-size: 14px;\n  color: #64748b;\n  margin: 0;\n}\n\n.manage-license-btn-refresh-global {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background-color: #ffffff;\n  color: #475569;\n  padding: 10px 18px;\n  border: 1px solid #cbd5e1;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.manage-license-btn-refresh-global:hover {\n  background-color: #f8fafc;\n  color: #0f172a;\n}\n\n.manage-license-btn-icon {\n  width: 16px;\n  height: 16px;\n}\n\n/* GRIDS AND CARDS */\n.manage-license-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 20px;\n  margin-bottom: 32px;\n}\n\n.manage-license-card {\n  background: #ffffff;\n  padding: 22px;\n  border-radius: 14px;\n  border: 1px solid #e2e8f0;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  position: relative;\n}\n\n.manage-license-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n}\n\n.manage-license-card h3 {\n  font-size: 13px;\n  color: #64748b;\n  margin: 0 0 8px 0;\n  align-item: center;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n}\n\n.manage-license-card p {\n  font-size: 28px;\n  font-weight: 800;\n  color: #0f172a;\n  margin: 0 0 6px 0;\n}\n\n.manage-license-filter-indicator {\n  font-size: 11px;\n  color: #94a3b8;\n  display: block;\n}\n\n/* Active State for Card Filter */\n.manage-license-active-card-filter {\n  background-color: #f1f5f9;\n  border-bottom: 2px solid #0f172a;\n}\n\n/* ADD NEW LICENSE CARD */\n.manage-license-add-card {\n  background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);\n  max-width: 150px;\n  border: none;\n}\n.manage-license-add-card h3 { color: #94a3b8; }\n.manage-license-add-card p { color: #ffffff; font-size: 20px; }\n.manage-license-add-card .manage-license-filter-indicator { color: #64748b; }\n\n/* ACTIONS BAR */\n.manage-license-table-actions-bar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n  gap: 16px;\n}\n\n.manage-license-search-box-wrapper {\n  position: relative;\n  flex: 1;\n  max-width: 480px;\n}\n\n.manage-license-search-icon {\n  position: absolute;\n  left: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 16px;\n  height: 16px;\n  color: #94a3b8;\n}\n\n.manage-license-search-input {\n  width: 100%;\n  padding: 10px 14px 10px 40px;\n  border: 1px solid #cbd5e1;\n  border-radius: 10px;\n  font-size: 14px;\n  background-color: #ffffff;\n  box-sizing: border-box;\n}\n\n.manage-license-active-filter-badge {\n  font-size: 13px;\n  color: #475569;\n  background-color: #e2e8f0;\n  padding: 6px 14px;\n  border-radius: 8px;\n}\n\n/* DATA TABLE CONFIG */\n.manage-license-responsive-table-wrapper {\n  background: #ffffff;\n  border-radius: 14px;\n  border: 1px solid #e2e8f0;\n  overflow-x: auto;\n}\n\n.manage-license-pro-table {\n  width: 100%;\n  border-collapse: collapse;\n  text-align: left;\n  font-size: 14px;\n}\n\n.manage-license-pro-table th {\n  background-color: #f8fafc;\n  color: #475569;\n  font-weight: 600;\n  padding: 14px 20px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.manage-license-pro-table td {\n  padding: 14px 20px;\n  border-bottom: 1px solid #f1f5f9;\n  color: #334155;\n}\n\n.manage-license-text-bold {\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.manage-license-network-badge {\n  background-color: #f1f5f9;\n  color: #475569;\n  padding: 4px 8px;\n  border-radius: 6px;\n  font-size: 12px;\n  border: 1px solid #e2e8f0;\n}\n\n.manage-license-key-display-block {\n  background-color: #f8fafc;\n  padding: 4px 8px;\n  border-radius: 6px;\n  font-family: monospace;\n  color: #2563eb;\n  border: 1px solid #e2e8f0;\n}\n\n/* STATUS BADGES SPECIFIC TO LICENSE INTERNAL VALUES */\n.manage-license-status-badge {\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: capitalize;\n  display: inline-block;\n}\n.manage-license-status-badge.active { background-color: #dcfce7; color: #15803d; }\n.manage-license-status-badge.expired { background-color: #fef3c7; color: #d97706; }\n.manage-license-status-badge.disabled { background-color: #fee2e2; color: #b91c1c; }\n\n/* ACTIONS ROW TRIGGER GROUP */\n.manage-license-table-row-actions {\n  display: flex;\n  gap: 6px;\n}\n\n.manage-license-btn-row-action {\n  padding: 6px 12px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  border: 1px solid transparent;\n  transition: all 0.15s ease;\n}\n\n.manage-license-btn-copy { background-color: #eff6ff; color: #1d4ed8; }\n.manage-license-btn-edit { background-color: #f1f5f9; color: #334155; border-color: #cbd5e1; }\n.manage-license-btn-revoke { background-color: #fff5f5; color: #dc2626; }\n\n.manage-license-btn-copy:hover { background-color: #dbeafe; }\n.manage-license-btn-edit:hover { background-color: #e2e8f0; }\n.manage-license-btn-revoke:hover { background-color: #fee2e2; }\n\n/* SPINNER & EMPTY STATE */\n.manage-license-loading-spinner-wrapper, .manage-license-no-data-cell {\n  text-align: center;\n  padding: 60px 20px;\n  color: #64748b;\n}\n\n.manage-license-spinner {\n  width: 32px;\n  height: 32px;\n  border: 3px solid #e2e8f0;\n  border-top-color: #2563eb;\n  border-radius: 50%;\n  margin: 0 auto 16px auto;\n  animation: lic-spin 0.8s linear infinite;\n}\n\n@keyframes lic-spin {\n  to { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
